module.exports = __webpack_public_path__ + "img/slide-4.c526624d.png";